<template>
  <div id="page_not_found">
    <section class="bg-cl-secondary py35 px20">
      <div class="container">
        <h3>
          {{ $t("We can't find the page") }}
        </h3>
      </div>
    </section>
    <section class="bg-cl-primary py35 px20">
      <div class="container">
        <div class="row">
          <div class="col-lg-9 static-content mb20">
            <div class="h4 weight-400 pt10 not-found-content">
              <cms-block-chunk :identifier="'c_404_TEXT'" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { Logger } from '@vue-storefront/core/lib/logger'
import i18n from '@vue-storefront/i18n'
import LazyHydrate from 'vue-lazy-hydration'
import ProductTile from '../components/core/ProductTile.vue'
import CmsBlockChunk from 'theme/components/core/blocks/Cms/BlockChunk';

export default {
  name: 'PageNotFound',
  computed: {
    ...mapGetters({
      ourBestsellersCollection: 'homepage/getBestsellers'
    })
  },

  metaInfo () {
    return {
      title: this.$route.meta.title || i18n.t('404 Page Not Found'),
      meta: this.$route.meta.description ? [{ vmid: 'description', name: 'description', content: this.$route.meta.description }] : []
    }
  },
  components: {
    ProductTile,
    LazyHydrate,
    CmsBlockChunk
  },
  methods: {
    toggleSearchpanel () {
      this.$store.commit('ui/setSearchpanel', true)
    }
  }
}
</script>

<style scoped>
  a {
    text-decoration: underline;
  }
</style>
